const getters = {
  videoPlayer: state => state.state.videoPlayer,
  liveState: state => state.state.liveState,
  initGood: state => state.state.initGood
}

export default getters
